var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInboundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#245C84"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(8 8)",
    fill: "#245C84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 12.8253L16.0475 17.5587L10.6663 12.8106V20.6667H16.6663V22H9.99967C9.63149 22 9.33301 21.7015 9.33301 21.3333V10.6667C9.33301 10.2985 9.63149 10 9.99967 10H21.9997C22.3679 10 22.6663 10.2985 22.6663 10.6667V16H21.333V12.8253ZM21.0003 11.3333H11.0073L16.0409 15.7747L21.0003 11.3333ZM21.333 20H23.333L20.6663 22.6667L17.9997 20H19.9997V17.3333H21.333V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundIcon);
export default __webpack_public_path__ + "static/media/InboundIcon.9c99933c8e275a4d2387efd02190b2a0.svg";
export { ForwardRef as ReactComponent };